<script>
// const httpUrl = "http://www.chenxing.com/" //本地
const httpUrl="https://author.morningstarsystem.tech/"//线上

export default {
    httpUrl
}
</script>

